module.exports = __webpack_public_path__ + "img/dryer.60fdeb34.svg";